var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
var CustomerDetailComponent = /** @class */ (function () {
    function CustomerDetailComponent(apiService, fb, util, activatedRoute) {
        this.apiService = apiService;
        this.fb = fb;
        this.util = util;
        this.activatedRoute = activatedRoute;
        this.contactId = "";
        this.emailSupervisor = "";
        this.contact = {};
        this.displayStyle = "none";
        this.submitted = false;
        this.oldEmail = "";
        this.countSendMail = 0;
        this.countRowError = 0;
        this.role = {};
        this.GetDataSave = new EventEmitter();
        this.form = this.fb.group({
            //username: ['', Validators.required],
            //password: ['', Validators.required]
            email: ['', Validators.required]
        });
    }
    Object.defineProperty(CustomerDetailComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    CustomerDetailComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CustomerDetailComponent.prototype.init = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            function matchCustom(params, data) {
                // If there are no search terms, return all of the data
                if ($.trim(params.term) === '') {
                    return data;
                }
                // Do not display the item if there is no 'text' property
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    // `params.term` should be the term that is used for searching
                    // `data.text` is the text that is displayed for the data object
                    if (data.text.indexOf(params.term) > -1) {
                        // You can return modified objects from here
                        // This includes matching the `children` how you want in nested data sets
                        return data;
                    }
                }
                // Return `null` if the term should not be displayed
                return null;
            }
            var thisTs, thisTs_1, tmp_portal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        thisTs = this;
                        if (!(this.contactId == "")) return [3 /*break*/, 2];
                        this.contactId = id;
                        thisTs_1 = this;
                        this.util.ShowWaiting(true);
                        console.log("detail on init");
                        return [4 /*yield*/, this.callApi()
                            //await this.initDropdown()
                            //await this.initControl()
                        ];
                    case 1:
                        _a.sent();
                        //await this.initDropdown()
                        //await this.initControl()
                        $('.select2').select2({
                            // matcher: function (term: any, text: any, option: any) {
                            //   return option.hasClass('car');
                            // }
                            matcher: matchCustom
                        });
                        $(".select2").on("change", function (e) {
                            thisTs_1.addressChange(e.target.value);
                        });
                        this.util.ShowWaiting(false);
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.apiService.get("crmservice", "getPortalLogin", "contactid=" + this.contactId)
                        //console.log(tmp_portal.password);
                    ];
                    case 3:
                        tmp_portal = _a.sent();
                        //console.log(tmp_portal.password);
                        if (tmp_portal.password != null && tmp_portal.password != '') {
                            $("#btnSend").addClass("sr-only");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.displayPopup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tmp_userCurrent_1, tmp_user, resC_1, reqUpdate, resC2, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.role.dpa_name.includes('Supervisor')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.save()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 2: return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", "callcenterId=" + this.cookieData.userId)];
                    case 3:
                        tmp_userCurrent_1 = _a.sent();
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterTeamSV", "customwebuserId=" + this.cookieData.userId)];
                    case 4:
                        tmp_user = _a.sent();
                        this.contact.dpa_modifiedby = new Date().toISOString();
                        return [4 /*yield*/, this.apiService.put("crmservice", "contactBeforeSave/" + this.contactId, this.contact)];
                    case 5:
                        resC_1 = _a.sent();
                        reqUpdate = {
                            email: tmp_userCurrent_1[0].dpa_emailaddress,
                            userId: this.cookieData.userId,
                            tokenLog: resC_1.ticketnumber
                        };
                        return [4 /*yield*/, this.apiService.post("crmservice", "contactUpdateBeforeSave", reqUpdate)];
                    case 6:
                        resC2 = _a.sent();
                        if (this.util.isSuccessResponse(resC_1)) {
                            res = void 0;
                            tmp_user.forEach(function (a) {
                                //console.log(a);
                                var req = {
                                    username: a.dpa_username,
                                    email: tmp_userCurrent_1[0].dpa_emailaddress,
                                    call_by: "1",
                                    url: _this.util.baseUrl(),
                                    userid: a.dpa_customwebuserid,
                                    tokenLog: resC_1.ticketnumber,
                                    contactname: tmp_userCurrent_1[0].dpa_name,
                                    firstname: _this.contact.firstname,
                                    lastname: _this.contact.lastname
                                };
                                _this.SendMailSV(req);
                            });
                            if (this.countRowError == 0) {
                                this.util.SuccessDialog("ระบบได้ส่งอีเมลไปยัง Supervisor เพื่ออนุมัติการแก้ไขข้อมูลผู้ติดต่อแล้ว");
                                this.countRowError = 0;
                                this.countSendMail = 0;
                            }
                            else {
                                this.util.ErrorDialog("ระบบไม่สามารถส่งอีเมลไปยัง Supervisor เพื่ออนุมัติการแก้ไขข้อมูลผู้ติดต่อ กรุณาติดต่อเจ้าหน้าที่");
                                this.countRowError = 0;
                                this.countSendMail = 0;
                            }
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.SendMailSV = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.postCustom("Crm", "SendMailSupervisor", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.countSendMail += 1;
                        }
                        else {
                            this.countRowError += 1;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.sendMailPortal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        // boy add
                        this.PortalLogin = {
                            firstname: this.contact.firstname,
                            lastname: this.contact.lastname,
                            usernameidno: this.contact.dpa_idcard,
                            username: this.contact.emailaddress1,
                            password: '',
                            passwordold1: '',
                            isactive: "1",
                            customerid: this.contactId,
                            createOn: null,
                            createBy: null,
                            pid: null,
                            modifiedOn: null,
                            modifiedBy: null,
                            usertype: "1",
                            call_by: "2",
                            url: 'https://dpacustportal.msccrm.com'
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("user", "ReSendMail", this.PortalLogin)];
                    case 1:
                        Res = _a.sent();
                        if (this.util.isSuccessResponse(Res)) {
                            this.util.ShowWaiting(false);
                            this.util.SuccessDialog("ระบบได้ส่งอีเมลยืนยันตัวตน สำหรับลงทะเบียนใช้งานระบบ Customer Web Portal แล้ว");
                        }
                        else {
                            this.util.ShowWaiting(false);
                            this.util.ErrorDialog("ไม่สามารถส่งอีเมลยืนยันตัวตน สำหรับลงทะเบียนใช้งานระบบ Customer Web Portal ได้ กรุณาติดต่อเจ้าหน้าที่");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.closePop = function () {
        this.displayStyle = "none";
    };
    CustomerDetailComponent.prototype.authorize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tmp_user_1, roleList, tmpRole, resC, req, res, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        this.submitted = true;
                        if (!this.form.valid) return [3 /*break*/, 8];
                        this.util.ShowWaiting(true);
                        this.emailSupervisor = this.form.get("email").value;
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", "email=" + this.form.get("email").value)];
                    case 1:
                        tmp_user_1 = _a.sent();
                        return [4 /*yield*/, this.apiService.get("master", "customwebrole")];
                    case 2:
                        roleList = _a.sent();
                        tmpRole = roleList.filter(function (r) {
                            return r.dpa_customwebroleid == tmp_user_1[0].dpa_roleid;
                        });
                        if (!tmpRole[0].dpa_name.includes('Supervisor')) return [3 /*break*/, 6];
                        this.contact.dpa_modifiedby = new Date().toISOString();
                        return [4 /*yield*/, this.apiService.put("crmservice", "contactBeforeSave/" + this.contactId, this.contact)];
                    case 3:
                        resC = _a.sent();
                        if (!this.util.isSuccessResponse(resC)) return [3 /*break*/, 5];
                        req = {
                            username: tmp_user_1[0].dpa_username,
                            email: this.emailSupervisor,
                            call_by: "1",
                            url: this.util.baseUrl(),
                            userid: tmp_user_1[0].dpa_customwebuserid,
                            tokenLog: resC.ticketnumber
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "SendMailSupervisor", req)];
                    case 4:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            this.util.SuccessDialog("ระบบได้ส่ง email สำหรับกำหนดรหัสผ่านใหม่ไปยัง email ของท่านแล้ว");
                        }
                        else {
                            this.util.ErrorDialog("ไม่สามารถส่ง email กำหนดรหัสผ่านใหม่ได้ กรุณาติดต่อเจ้าหน้าที่");
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        //this.util.WarningDialog("ไม่สามารถบันทึกได้ เนื่องจาก Username นี้ไม่ใช่ Supervisor")
                        this.util.WarningDialog("ไม่สามารถส่ง Email ได้ เนื่องจาก Email นี้ไม่ใช่ Supervisor");
                        _a.label = 7;
                    case 7:
                        //this.util.ShowWaiting(false)
                        this.displayStyle = "none";
                        _a.label = 8;
                    case 8:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 10];
                    case 9:
                        ex_1 = _a.sent();
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog(ex_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.callApi = function () {
        return forkJoin([
            this.initDropdown(),
            this.initControl()
        ]);
    };
    CustomerDetailComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, , 6]);
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "country")];
                    case 1:
                        _a.countryList = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 2:
                        _b.combinedAddressList = _e.sent();
                        _c = this;
                        return [4 /*yield*/, this.apiService.get("master", "personalType")];
                    case 3:
                        _c.personalTypeList = _e.sent();
                        _d = this;
                        return [4 /*yield*/, this.apiService.get("master", "companyType")];
                    case 4:
                        _d.companyTypeList = _e.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _e.sent();
                        console.log(e_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.CopyAddress = function (event) {
        if (event.target.checked) {
            this.contact.dpa_contact_subdistict = this.contact.dpa_registration_subdistict;
            this.contact.dpa_contact_distict = this.contact.dpa_registration_distict;
            this.contact.dpa_contact_province = this.contact.dpa_registration_province;
            this.contact.dpa_contact_postcode = this.contact.dpa_registration_postcode;
            this.contact.dpa_contact_country = this.contact.dpa_registration_country;
            this.contact.dpa_contact_subdistictname = this.contact.dpa_registration_subdistictname;
            this.contact.dpa_contact_distictname = this.contact.dpa_registration_distictname;
            this.contact.dpa_contact_provincname = this.contact.dpa_registration_provincename;
            this.contact.dpa_contact_postcodename = this.contact.dpa_registration_postcodename;
            this.contact.dpa_contact_countryname = this.contact.dpa_registration_countryname;
            this.contact.dpa_contact_homeno = this.contact.dpa_registration_homeno;
            this.contact.dpa_contact_street = this.contact.dpa_registration_street;
            this.contact.dpa_contact_moo = this.contact.dpa_registration_moo;
        }
    };
    CustomerDetailComponent.prototype.getObjectByKey = function (objList, key, value) {
        return objList.find(function (k) { return k[key] == value; });
    };
    CustomerDetailComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = selected[0].text.split(" | ");
            this.contact.dpa_contact_subdistict = values[0];
            this.contact.dpa_contact_distict = values[1];
            this.contact.dpa_contact_province = values[2];
            this.contact.dpa_contact_postcode = values[3];
            this.contact.dpa_contact_country = values[4];
            this.contact.dpa_contact_subdistictname = texts[0];
            this.contact.dpa_contact_distictname = texts[1];
            this.contact.dpa_contact_provincname = texts[2];
            this.contact.dpa_contact_postcodename = texts[3];
            this.contact.dpa_contact_countryname = texts[4];
        }
        else {
            this.contact.dpa_contact_subdistict = "";
            this.contact.dpa_contact_distict = "";
            this.contact.dpa_contact_province = "";
            this.contact.dpa_contact_postcode = "";
            this.contact.dpa_contact_country = "";
            this.contact.dpa_contact_subdistictname = "";
            this.contact.dpa_contact_distictname = "";
            this.contact.dpa_contact_provincname = "";
            this.contact.dpa_contact_postcodename = "";
            this.contact.dpa_contact_countryname = "";
        }
    };
    CustomerDetailComponent.prototype.close = function () {
        window.close();
    };
    CustomerDetailComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.contactId;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.initControl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _b.sent();
                        this.oldEmail = this.contact.emailaddress1;
                        this.GetDataSave.emit(this.contact);
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, updateSucceed, notiReq;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!this.isFormValid()) return [3 /*break*/, 5];
                        this.util.ShowWaiting(true);
                        this.contact.dpa_modifiedby = new Date().toISOString();
                        return [4 /*yield*/, this.apiService.put("crmservice", "contact/" + this.contactId, this.contact)];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 3];
                        this.GetDataSave.emit(this.contact);
                        return [4 /*yield*/, this.registerDROS()];
                    case 2:
                        _a.sent();
                        if (this.oldEmail != null && this.oldEmail != "" && this.oldEmail != this.contact.emailaddress1) {
                            updateSucceed = this.updatePortalLogin();
                            notiReq = {
                                firstname: this.contact.firstname,
                                lastname: this.contact.lastname,
                                callBy: "1",
                                newMail: this.contact.emailaddress1,
                                oldMail: this.oldEmail
                            };
                            this.apiService.postCustom("crm", "NotiEmailChange", notiReq);
                        }
                        this.util.SuccessDialog("แก้ไขข้อมูลสำเร็จ");
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("แก้ไขข้อมูลไม่สำเร็จ");
                        _a.label = 4;
                    case 4:
                        this.util.ShowWaiting(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.isFormValid = function () {
        if (this.contact.emailaddress1 == null) {
            this.contact.emailaddress1 = "";
        }
        if (this.contact.telephone1 == null) {
            this.contact.telephone1 = "";
        }
        if (this.contact.dpa_contact_homeno == null) {
            this.contact.dpa_contact_homeno = "";
        }
        if (this.contact.dpa_contact_country == null) {
            this.contact.dpa_contact_country = "";
        }
        return this.contact.emailaddress1 != null &&
            this.contact.emailaddress1.trim().length > 0 &&
            this.isValidMail(this.contact.emailaddress1.trim()) &&
            this.contact.telephone1 != null &&
            this.contact.telephone1.trim().length > 0;
    };
    CustomerDetailComponent.prototype.isValidMail = function (mail) {
        if (mail) {
            var matches = mail.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? true : false;
        }
        else {
            return true;
        }
    };
    // async SendNewEmail() {
    //   let MailObj: any = {
    //     dpa_name: "อีเมลของท่านได้รับการเปลี่ยนแล้ว",
    //     dpa_emailaddress: this.contact.emailaddress1
    //   };
    //   var MailContent = "เรียน คุณ" + this.contact.firstname + " " + (this.contact.lastname || "" ) + "<br /><br />" +
    //     "   อีเมลนี้ของคุณได้รับการบันทึกในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
    //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด  <br /><br />" +
    //     "ขอแสดงความนับถือ <br />" +
    //     "สถาบันคุ้มครองเงินฝาก <br />" +
    //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
    //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
    //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
    //     "โทร : 02-272-0300";
    //   MailObj.dpa_description = MailContent;
    //   MailObj.dpa_callby = 1
    //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    //   return Res;
    // }
    // async SendOldEmail() {
    //   let MailObj: any = {
    //     dpa_name: "อีเมลของท่านได้ถูกเปลี่ยนแล้ว",
    //     dpa_emailaddress: this.oldEmail
    //   };
    //   var MailContent = "เรียน คุณ" + this.contact.firstname + " " + (this.contact.lastname || "" ) + "<br /><br />" +
    //     "   อีเมลของคุณได้เปลี่ยนในระบบ Call Center ของสถาบันคุ้มครองเงินฝาก <br />" +
    //     "หากท่านไม่ได้เป็นผู้ดำเนินการ กรุณาติดต่อเจ้าหน้าที่โดยเร็วที่สุด <br /><br />" +
    //     "ขอแสดงความนับถือ <br />" +
    //     "สถาบันคุ้มครองเงินฝาก <br />" +
    //     "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
    //     "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
    //     "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
    //     "โทร : 02-272-0300";
    //   MailObj.dpa_description = MailContent;
    //   MailObj.dpa_callby = 1
    //   let Res = await this.apiService.post("crmservice", "sendEmail", MailObj);
    //   return Res;
    // }
    CustomerDetailComponent.prototype.registerDROS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idcard, para, tmp, UID, SubdistictCode, PostalName, SubdistictObj, PostalObj, arrAddr, rowAddr, birthdateYYYYMMDD, rowSave, Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idcard = this.contact.dpa_idcard;
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false&CRM06=true";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        if (!!this.util.IsNullOrUndefined(tmp.CRM06)) return [3 /*break*/, 5];
                        UID = tmp.CRM06.UID;
                        SubdistictCode = "";
                        PostalName = "";
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Subdistrict", { id: this.contact.dpa_contact_subdistict })];
                    case 2:
                        SubdistictObj = _a.sent();
                        return [4 /*yield*/, this.apiService.postCustomApi("master", "Postalcode", { id: this.contact.dpa_contact_postcode })];
                    case 3:
                        PostalObj = _a.sent();
                        if (!this.util.IsNullOrUndefined(SubdistictObj)) {
                            SubdistictCode = SubdistictObj[0].dpa_code;
                        }
                        if (!this.util.IsNullOrUndefined(PostalObj)) {
                            PostalName = PostalObj[0].dpa_name;
                        }
                        arrAddr = [];
                        rowAddr = {
                            addressType: "2",
                            addressNo: this.contact.dpa_contact_homeno,
                            villageName: null,
                            floor: null,
                            mooNo: this.contact.dpa_contact_moo,
                            soiName: null,
                            streetName: this.contact.dpa_contact_street,
                            locationCode: SubdistictCode,
                            zipcode: PostalName
                        };
                        birthdateYYYYMMDD = "";
                        if (this.contact.birthdate != "") {
                            birthdateYYYYMMDD = moment(this.contact.birthdate).format("YYYY/MM/DD");
                        }
                        arrAddr.push(rowAddr);
                        rowSave = {
                            uid: UID,
                            idNo: idcard,
                            title: null,
                            firstName: this.contact.firstname,
                            lastName: this.contact.lastname,
                            birthdate: birthdateYYYYMMDD,
                            mobileNo: this.contact.telephone1,
                            email: this.contact.emailaddress1,
                            address: arrAddr
                        };
                        return [4 /*yield*/, this.apiService.post("DROS", "register", rowSave)];
                    case 4:
                        Res = _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CustomerDetailComponent.prototype.updatePortalLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {
                            username: this.contact.emailaddress1,
                            usernameidno: this.contact.dpa_idcard,
                            oldEmail: this.oldEmail
                        };
                        return [4 /*yield*/, this.apiService.postCustom("User", "UpdateEmailLogin", req)];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            return [2 /*return*/, true];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CustomerDetailComponent;
}());
export { CustomerDetailComponent };



// WEBPACK FOOTER //
// ./src/app/customer-detail/customer-detail.component.ts.pre-build-optimizer.js